module.exports = __webpack_public_path__ + "static/media/download.ae49f673.pdf";